import Vue from 'vue'
import VueRouter from 'vue-router'
import {fb} from '@/firebase'

  // Front Without Auth
import Home from '@/views/Home.vue'
import Error_Page from '@/views/404.vue'

  // Front With Auth
import Cart from '@/views/Cart/Index.vue'
import Bids from '@/views/Cart/Bids/Index.vue'
import Wish from '@/views/Cart/Wishlist/Index.vue'
import Orders from '@/views/Orders/Index.vue'// (order detials)
import OrderDetail from '@/views/Orders/OrderDetail.vue'
import Checkout from '@/views/Checkout/Index.vue'//(orders)
import ReviewsAlt from '@/views/Reviews/IndexAlt.vue'
import Reviews from '@/views/Reviews/Index.vue'
import Reserve from '@/views/Reserve/Index.vue'

  // Authentication
import SignIn from '@/views/Auth/SignIn.vue'
import SignUp from '@/views/Auth/SignUp.vue'
import SignInAlt from '@/views/Auth/SignInAlt.vue'
import SignUpExtra from '@/views/Auth/SignUpExtra.vue'

 // User Profile
import Dash from '@/views/Auth/Dashboard.vue'
import DashHome from '@/views/Auth/Components/Home.vue'
import UserProfile from '@/views/Auth/Components/Profile.vue'
import Qrcode from '@/views/Auth/Components/QrcodeReader.vue'
import DashNotification from '@/views/Auth/Components/Notification.vue'
import DashPayment from '@/views/Auth/Components/Payment.vue'
import DashLogs from '@/views/Auth/Components/Transactions.vue'
import DashSettings from '@/views/Auth/Components/Settings.vue'
import DashReports from '@/views/Auth/Components/Issues.vue'
import DashReportsAlt from '@/views/Auth/Components/IssuesAlt.vue'

  // Documents
import DocAbout from '@/views/Documents/AboutUs.vue'
import DocDisclaimer from '@/views/Documents/Disclaimer.vue'
import DocTermsCondition from '@/views/Documents/Terms_Conditions.vue'
import DocTermsUse from '@/views/Documents/TermsOfUse.vue'
import DocRefund from '@/views/Documents/Return_RefundPolicy.vue'
import DocCookies from '@/views/Documents/CookiesPolicy.vue'
import DocPrivacy from '@/views/Documents/PrivacyPolicy.vue'
import DocEULA from '@/views/Documents/EULA.vue'

// Categories
import Products from '@/views/Category/products.vue'
import Services from '@/views/Category/services.vue'
import Events from '@/views/Category/events.vue'
import Clients from '@/views/Category/clients.vue'
import SubCategories from '@/views/Category/subcategories.vue'

// Alternative Categories
import AltProducts from '@/views/Category/Alternate/altProducts.vue'
import AltServices from '@/views/Category/Alternate/altServices.vue'
import AltEvents from '@/views/Category/Alternate/altEvents.vue'
import AltClients from '@/views/Category/Alternate/altClients.vue'

// Channels
import Product from '@/views/Channels/Product/Index.vue'
import Service from '@/views/Channels/Service/Index.vue'
import Event from '@/views/Channels/Event/Index.vue'
import Client from '@/views/Channels/Client/Index.vue'

// Alt Channels
import ProductAlt from '@/views/Channels/Product/IndexAlt.vue'
import ServiceAlt from '@/views/Channels/Service/IndexAlt.vue'
import EventAlt from '@/views/Channels/Event/IndexAlt.vue'
import ClientAlt from '@/views/Channels/Client/IndexAlt.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/404',
    name: 'error',
    component: Error_Page,
    meta: { Auth: false, title: 'Error Page' }
  },
  {
    path: '*',
    component: Error_Page,
    meta: { Auth: false, title: 'Error Page' }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { Auth: false, title: 'Home' }
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignIn,
    meta: { Auth: false, title: 'SignIn' }
  },
  {
    path: '/signin?return/:slug',
    name: 'signin_alt',
    component: SignInAlt,
    meta: { Auth: false, title: 'SignIn' }
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUp,
    meta: { Auth: false, title: 'SignUp' }
  },
  {
    path: '/signup_extra',
    name: 'signup_extra',
    component: SignUpExtra,
    meta: { Auth: false, title: 'SignUp' }
  },
  {
    path: '/documents/about-us',
    name: 'docAbout',
    component: DocAbout,
    meta: { Auth: false, title: 'AboutUs' }
  },
  {
    path: '/documents/disclaimer',
    name: 'docDisclaimer',
    component: DocDisclaimer,
    meta: { Auth: false, title: 'Disclaimer' }
  },
  {
    path: '/documents/terms-and-conditions',
    name: 'docTermsCondition',
    component: DocTermsCondition,
    meta: { Auth: false, title: 'Terms & Conditions' }
  },
  {
    path: '/documents/terms-of-service',
    name: 'docTermsUse',
    component: DocTermsUse,
    meta: { Auth: false, title: 'Terms Of Use' }
  },
  {
    path: '/documents/return-and-refund-policy',
    name: 'docRefund',
    component: DocRefund,
    meta: { Auth: false, title: 'Refunds' }
  },
  {
    path: '/documents/cookies',
    name: 'docCookies',
    component: DocCookies,
    meta: { Auth: false, title: 'Cookies Policy' }
  },
  {
    path: '/documents/privacy-policy',
    name: 'docPrivacy',
    component: DocPrivacy,
    meta: { Auth: false, title: 'Privacy Policy' }
  },
  {
    path: '/documents/end-user-license-agreement',
    name: 'docEULA',
    component: DocEULA,
    meta: { Auth: false, title: 'EULA' }
  },
  {
    path: '/products/:slug',
    name: 'products',
    component: Products,
    meta: { Auth: false, title: 'Products' }
  },
  {
    path: '/services/:slug',
    name: 'services',
    component: Services,
    meta: { Auth: false, title: 'Services' }
  },
  {
    path: '/events/:slug',
    name: 'events',
    component: Events,
    meta: { Auth: false, title: 'Events' }
  },
  {
    path: '/clients/:slug',
    name: 'clients',
    component: Clients,
    meta: { Auth: false, title: 'Clients' }
  },
  {
    path: '/subcategories/:slug',
    name: 'subcategories',
    component: SubCategories,
    meta: { Auth: false, title: 'SubCategories' }
  },
  {
    path: '/products/:slug',
    name: 'alt_products',
    component: AltProducts,
    meta: { Auth: false, title: 'Products' }
  },
  {
    path: '/services/:slug',
    name: 'alt_services',
    component: AltServices,
    meta: { Auth: false, title: 'Services' }
  },
  {
    path: '/events/:slug',
    name: 'alt_events',
    component: AltEvents,
    meta: { Auth: false, title: 'Events' }
  },
  {
    path: '/clients/:slug',
    name: 'alt_clients',
    component: AltClients,
    meta: { Auth: false, title: 'Clients' }
  },
  {
    path: '/product/:slug',
    name: 'product',
    component: Product,
    meta: { Auth: false, title: 'Product' }
  },
  {
    path: '/service/:slug',
    name: 'service',
    component: Service,
    meta: { Auth: false, title: 'Service' }
  },
  {
    path: '/event/:slug',
    name: 'event',
    component: Event,
    meta: { Auth: false, title: 'Event' }
  },
  {
    path: '/client/:slug',
    name: 'client',
    component: Client,
    meta: { Auth: false, title: 'Client' }
  },
  {
    path: '/.product/:slug',
    name: 'product_alt',
    component: ProductAlt,
    meta: { Auth: false, title: 'Product' }
  },
  {
    path: '/.service/:slug',
    name: 'service_alt',
    component: ServiceAlt,
    meta: { Auth: false, title: 'Service' }
  },
  {
    path: '/.event/:slug',
    name: 'event_alt',
    component: EventAlt,
    meta: { Auth: false, title: 'Event' }
  },
  {
    path: '/.client/:slug',
    name: 'client_alt',
    component: ClientAlt,
    meta: { Auth: false, title: 'Client' }
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart,
    meta: { Auth: true, title: 'Cart' }
  },
  {
    path: '/bids',
    name: 'bids',
    component: Bids,
    meta: { Auth: true, title: 'Bids' }
  },
  {
    path: '/wishlist',
    name: 'wish',
    component: Wish,
    meta: { Auth: true, title: 'WishList' }
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders,
    meta: { Auth: true, title: 'Orders' }
  },
  {
    path: '/orders/:id',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: { Auth: true, title: 'Order Details' }
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: Checkout,
    meta: { Auth: true, title: 'Checkout' }
  },
  {
    path: '/reviews/:slug',
    name: 'reviews',
    component: Reviews,
    meta: { Auth: true, title: 'Reviews' }
  },
  {
    path: '/.reviews/:slug',
    name: 'reviews_alt',
    component: ReviewsAlt,
    meta: { Auth: true, title: 'Reviews' }
  },
  {
    path: '/reserve',
    name: 'reserve',
    component: Reserve,
    meta: { Auth: true, title: 'Reserve' }
  },
  {
    path: '/dashboard/',
    name: 'dashboard',
    component: Dash,
    meta: { Auth: true},
    children: [
      {
        path: 'home',
        name: 'dashboard_home',
        component: DashHome,
        meta: { title: 'Dashboard' }
      },
      {
        path: 'profile',
        name: 'dashboard_profile',
        component: UserProfile,
        meta: { title: 'User Profile' }
      },
      {
        path: 'qrcode',
        name: 'dashboard_qrcode',
        component:Qrcode,
        meta: { title: 'Qrcode Reader' }
      },
      {
        path: 'notifications',
        name: 'dashboard_notifications',
        component: DashNotification,
        meta: { title: 'Notifications' }
      },
      {
        path: 'payment',
        name: 'dashboard_payment',
        component: DashPayment,
        meta: { title: 'Payments' }
      },
      {
        path: 'transactions',
        name: 'dashboard_transactions',
        component: DashLogs,
        meta: { title: 'Transaction Logs' }
      },
      {
        path: 'settings',
        name: 'dashboard_settings',
        component: DashSettings,
        meta: { title: 'Settings' }
      },
      {
        path: 'issues',
        name: 'dashboard_issues',
        component: DashReports,
        meta: { title: 'Report Issues' }
      },
      {
        path: '.issues',
        name: 'dashboard_issues_alt',
        component: DashReportsAlt,
        meta: { title: 'Report Issues' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  const Auth = to.matched.some(x => x.meta.Auth)
  const currentUser = fb.auth().currentUser

  if (Auth && !currentUser) {
    next('/signin')
  } else if (Auth && currentUser) {
    next()
  } else {
    next()
  }
})

export default router
